import React from 'react';
import {Row, Col} from 'react-bootstrap';
import Page from './Page';

import '../css/HowItWorks.css';

import Step1 from '../assets/How it works/Step-1.jpg';
import Step2 from '../assets/How it works/Step-2.jpg';
import Step3 from '../assets/How it works/Step-3.jpg';
import Step4 from '../assets/How it works/Step-4.jpg';
import Step5 from '../assets/How it works/Step-5.jpg';
import Step6 from '../assets/How it works/Step-6.jpg';

import FiveTimes from '../assets/Homepage/5x_dose_en.png';
import FiveTimes_Fr from '../assets/Homepage/5x_dose_fr.png';

import WhatMatters from '../assets/How it works/WhatMatters.jpg';
import TwentyFive_4 from '../assets/How it works/25_4.png';
import LRVHP from '../assets/How it works/LRVHP.png';

class HowItWorks extends Page{
    constructor(props) {
        super(props);
        this.goToHomePage = this.goToHomePage.bind(this);

    }

    goToHomePage(){
        this.props.setPage("home")
    }

    handleFeatureClick(e){
        var curr_feature
        var state = this.state;
        curr_feature = parseInt(e.currentTarget.getAttribute("data"), 10);
        state.curr_feature = curr_feature;
        this.setState({state});

    }

    componentDidMount() {
        document.title = "How It Works | Vetradent™";
    }

    render(){
        var five_times_img_src = this.props.Settings.language === 'en' ? FiveTimes : FiveTimes_Fr;

        var lrvhp = []
        if (this.props.Settings.country === "CA"){
            lrvhp.push(
                <div key = "0" className = "LRVHP">
                    <Row>
                        <Col xs={8}>
                            <h2>{this.contentParser("lrvhp-headline")}</h2>
                            <p>{this.contentParser("lrvhp-text")}</p>
                        </Col>
                        <Col xs={4} className = "hidden-sm">
                            <img src={LRVHP} alt={"LRVHP Logo"} />
                        </Col>
                    </Row>
                </div>
            )
        }

        // May contain ingredients - only for US locale
        var maybeContainedIngredientsTable;
        if (this.props.Settings.country === 'US') {
            maybeContainedIngredientsTable =
                <div className = "custom-table">
                    <div className = "table-header"> {this.contentParser("ingredients-maybe-contained-headline")} </div>
                    <div className = "table-row">{this.contentParser("maybe-contained-ingredients")} </div>
                </div>
        }

        return(
            <div className="how-it-works">
                <div className = "chunk-grey">
                    <div className="breadcrumbs"><a aria-label="home page" onClick={this.goToHomePage} className="breadcrumb-home">Home</a><div className="breadcrumb-page">&nbsp; How It Works</div></div>

                    <h1 className ="accent-headline">{this.contentParser("headline")}</h1>
                    <p className ="accent-text">{this.contentParser("headline-text")}</p>

                    <Row>
                        <Col xsHidden={true}  smHidden = {true} md={3}>
                            <img src={Step1} className = "step-img" alt="Step 1 Diagram" />
                        </Col>
                        <Col sm={12} md={9} lg={7}>
                            <h2>{this.contentParser("step-1")}</h2>
                            <p className="neutral-text">{this.contentParser("step-1-text")}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xsHidden={true}  smHidden = {true} md={3}>
                            <img src={Step2} className = "step-img" alt="Step 2 Diagram" />
                        </Col>
                        <Col sm={12} md={9} lg={7}>
                            <h2>{this.contentParser("step-2")}</h2>
                            <p className="neutral-text">{this.contentParser("step-2-text")}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xsHidden={true}  smHidden = {true} md={3}>
                            <img src={Step3} className = "step-img" alt="Step 3 Diagram" />
                        </Col>
                        <Col sm={12} md={9} lg={7}>
                            <h2>{this.contentParser("step-3")}</h2>
                            <p className="neutral-text">{this.contentParser("step-3-text")}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xsHidden={true}  smHidden = {true} md={3}>
                            <img src={Step4} className = "step-img" alt="Step 4 Diagram" />
                        </Col>
                        <Col sm={12} md={9} lg={7}>
                            <h2>{this.contentParser("step-4")}</h2>
                            <p className="neutral-text">{this.contentParser("step-4-text")}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xsHidden={true}  smHidden = {true} md={3}>
                            <img src={Step5} className = "step-img" alt="Step 5 Diagram" />
                        </Col>
                        <Col sm={12} md={9} lg={7}>
                            <h2>{this.contentParser("step-5")}</h2>
                            <p className="neutral-text">{this.contentParser("step-5-text")}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xsHidden={true}  smHidden = {true} md={3}>
                            <img src={Step6} className = "step-img" alt="Step 6 Diagram" />
                        </Col>
                        <Col sm={12} md={9} lg={7}>
                            <h2>{this.contentParser("step-6")}</h2>
                            <p className="neutral-text">{this.contentParser("step-6-text")}</p>
                        </Col>
                    </Row>
                </div>

                <div style={{backgroundImage:"url("+WhatMatters+")"}} className = "what-matters-chunk">
                    <Row>
                        <Col xs={12} sm={12} md={6}>
                            <h1>{this.contentParser("what-matters")}</h1>
                            <h2>{this.contentParser("what-matters-efficacy")}</h2>
                            <p>{this.contentParser("what-matters-efficacy-text")}</p>
                        </Col>
                    </Row>
                </div>
                <div className = "brown-chunk">
                    <Row>
                        <Col xs = {12} sm = {12} md={8}>
                            <h2>{this.contentParser("what-matters-results")}</h2>
                            <p>{this.contentParser("what-matters-results-text")}</p>
                        </Col>
                        <Col xsHidden smHidden md={4}>
                            <div className = {"twenty-five"} >
                                <img  src={TwentyFive_4} alt={"Tartar Impact Diagram"} />

                                <p className={"strong-text max-width"}>{this.contentParser("what-matters-conclusion")}</p>
                            </div>

                        </Col>
                    </Row>
                </div>
                <div className ="chunk-md-grey">
                    <Row>
                        <Col xs={12} sm={12} md={8}>
                            <h2>{this.contentParser("safety-headline")} </h2>
                            <p className="neutral-text">{this.contentParser("safety-text")}</p>
                            <h2>{this.contentParser("results-headline")} </h2>
                            <p className="neutral-text">{this.contentParser("results-text")}</p>
                        </Col>
                        <Col xsHidden smHidden xs={4}>
                            {this.props.Settings.country === "CA" &&
                                <div className="safety-img-container">
                                    <img src={five_times_img_src} className="safety-img"
                                         alt="Safe at 5 times recommended dosage"/>
                                    <p className="strong-text max-width">{this.contentParser("results-conclusion")}</p>
                                </div>
                            }
                        </Col>

                    </Row>
                </div>
                {lrvhp}
                <div className ="chunk-md-grey">
                    <h2>{this.contentParser("ingredients-headline")} </h2>
                    <div className = "custom-table">
                        <div className = "table-header"> {this.contentParser("ingredients-active-headline")} </div>
                        <div className = "table-row">{this.contentParser("active-ingredient-1")} </div>
                        <div className = "table-row">{this.contentParser("active-ingredient-2")} </div>
                        <div className = "table-row">{this.contentParser("active-ingredient-3")} </div>
                    </div>
                    <div className = "custom-table">
                        <div className = "table-header"> {this.contentParser("ingredients-inactive-headline")} </div>
                        <div className = "table-row">{this.contentParser("inactive-ingredient-1")} </div>
                        <div className = "table-row">{this.contentParser("inactive-ingredient-2")} </div>
                    </div>
                    {maybeContainedIngredientsTable}

                    {this.props.Settings.country !== "CA" &&
                    <p className = "neutral-text">
                        {this.contentParser("efficacy-footnote")}
                    </p>
                    }
                </div>





            </div>
        )


    }
}

export default HowItWorks;


// WEBPACK FOOTER //
// ./src/components/HowItWorks.js